import { Box, Grid, Paper, Typography } from "@mui/material";
import { Message, Profile } from "@readyfit-common/models";
import { useAppSelector } from "src/store/hooks";
import { selectCurrentUser } from "src/store/reducers/auth/authSlice";
import AthleteIcon from "src/grading/components/AthleteIcon/AthleteIcon";
import useStyles from "./MessageItem.style";

export default function MessageItem({ message }: { message: Message }) {
  const profile: Profile = useAppSelector(selectCurrentUser);
  const classes = useStyles();
  return (
    <Box
      key={message.id}
      sx={{
        display: "flex",
        justifyContent:
          message.senderId === profile.id
            ? "flex-end"
            : "flex-start",
        mb: 2,
      }}
    >
      <Box
        sx={{
          maxWidth: "70%",
          display: "flex",
          alignItems: "flex-start",
          gap: 2,
        }}
      >
        {message.senderId !== profile.id && (
          <AthleteIcon
            profile={
              {
                firstName: message.senderName,
              } as Profile
            }
            customStyles={classes.messageIcon}
          />
        )}
        <Box>
          <Grid container>
            <Typography variant="caption" marginLeft={"auto"}>
              {message.senderName}
            </Typography>
          </Grid>
          <Paper
            sx={{
              p: 1.5,
              backgroundColor:
                message.senderId === profile.id
                  ? "#C5D9CF"
                  : "#F2F2F2",
              borderRadius: 2,
            }}
          >
            <Typography variant="caption">
              {message.message}
            </Typography>
          </Paper>
        </Box>
        {message.senderId === profile.id && (
          <AthleteIcon
            profile={profile}
            customStyles={classes.messageIcon}
          />
        )}
      </Box>
    </Box>
  )
}